import React, { useState } from 'react';
import { useCustomerProducts } from '../hooks/useCustomerProduct';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Container, Box, Pagination, Alert, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function CustomerProduct() {
  const { customerProducts, page, totalPages, setPage, setSearchQuery, error } = useCustomerProducts();
  const [searchText, setSearchText] = useState<string>('');

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleSearch = () => {
    setSearchQuery(searchText);
    setPage(1);
  };

  return (
    <Container>
      <h2>顧客商品管理</h2>
      <Box display="flex" justifyContent="space-between" mb={5}>
        <TextField
          variant="outlined"
          placeholder="顧客名で検索"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleSearch}>
                  <SearchIcon />
                </Button>
              </InputAdornment>
            ),
          }}
          sx={{ maxHeight: 10 }}
        />
      </Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>顧客商品コード</TableCell>
            <TableCell>顧客コード<br />顧客名</TableCell>
            <TableCell>商品コード<br />商品名</TableCell>
            <TableCell>商品キーワード</TableCell>
            <TableCell>価格</TableCell>
            <TableCell>並び順</TableCell>
            <TableCell>最終更新日時</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {customerProducts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.id}</TableCell>
              <TableCell>{item.customer_id}<br />{item.customer_name}</TableCell>
              <TableCell>{item.product_id}<br />{item.product_name}</TableCell>
              <TableCell>{item.product_keyword}</TableCell>
              <TableCell>¥{item.price}</TableCell>
              <TableCell>{item.sort}</TableCell>
              <TableCell>{item.updated_at?.replace('T', ' ').split('+')[0]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
      </Box>
    </Container>
  );
}
